import { render, staticRenderFns } from "./ArrearList.vue?vue&type=template&id=6a297e47&scoped=true&"
import script from "./ArrearList.vue?vue&type=script&lang=js&"
export * from "./ArrearList.vue?vue&type=script&lang=js&"
import style0 from "./ArrearList.vue?vue&type=style&index=0&id=6a297e47&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a297e47",
  null
  
)

export default component.exports